export default __webpack_public_path__ + "static/media/followIcon.6f1376ba.svg";